import React from "react";
import { useSelector } from "react-redux";
import { useEffect } from "react";
import { Carousel } from "react-responsive-carousel";
import singapore from "../assets/places/singapur/singapur3.jpg";
import "react-responsive-carousel/lib/styles/carousel.min.css"; // For carousel styling
import { FaPassport, FaPlaneDeparture, FaCar } from "react-icons/fa";
import CustomizedForm from "../components/OrderPopup/Forms";

const Visa = () => {
  const theme = useSelector((state) => state.theme.theme); // Access the current theme
  const isDarkTheme = theme === "dark";

  useEffect(() => {
    // Scroll to top when the component mounts
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className={`${isDarkTheme ? "bg-black text-white" : "bg-white text-black"} min-h-screen`}>
      {/* Hero Section */}
      <div
        className="relative bg-cover bg-center h-[60vh] flex items-center justify-center"
        style={{
          backgroundImage: `url(${singapore})`,
        }}
      >
        <div
          className={`${
            isDarkTheme ? "bg-black bg-opacity-50" : "bg-gray-200"
          } p-8 rounded-md text-center`}
        >
          <h1 className={`${isDarkTheme ? "text-[#5b53fb]" : "text-[#5b53fb]"} text-4xl font-bold`}>
            Apply for a Visa
          </h1>
          <p className="mt-2 text-lg font-light">
            Hassle-free Visa applications and exclusive travel offers just for you!
          </p>
        </div>
      </div>

      {/* Carousel Section */}
      <section className="py-8">
        <h2
          className={`${
            isDarkTheme ? "text-[#5b53fb]" : "text-[#5b53fb]"
          } text-2xl font-bold text-center mb-6`}
        >
          Exclusive Offers
        </h2>
        <Carousel
          showThumbs={false}
          infiniteLoop
          autoPlay
          interval={3000}
          showStatus={false}
        >
          <div className={`${isDarkTheme ? "bg-[#5b53fb]" : "bg-[#dcdafc]"} flex justify-center items-center p-4`}>
            <FaPlaneDeparture size={50} className={`${isDarkTheme ? "text-white" : "text-black"} mr-4`} />
            <div>
              <h3 className="text-lg font-semibold">Flight Discounts</h3>
              <p>Up to 20% off on international flights.</p>
            </div>
          </div>
          <div className={`${isDarkTheme ? "bg-[#5b53fb]" : "bg-[#dcdafc]"} flex justify-center items-center p-4`}>
            <FaCar size={50} className={`${isDarkTheme ? "text-white" : "text-black"} mr-4`} />
            <div>
              <h3 className="text-lg font-semibold">Car Rentals</h3>
              <p>Special offers on car rentals in top destinations.</p>
            </div>
          </div>
          <div className={`${isDarkTheme ? "bg-[#5b53fb]" : "bg-[#dcdafc]"} flex justify-center items-center p-4`}>
            <FaPassport size={50} className={`${isDarkTheme ? "text-white" : "text-black"} mr-4`} />
            <div>
              <h3 className="text-lg font-semibold">Priority Visa Processing</h3>
              <p>Get your visa faster with premium services.</p>
            </div>
          </div>
        </Carousel>
      </section>

      {/* Form Section */}
      <section
        className={`${
          isDarkTheme ? "bg-black border-[#5b53fb]" : "bg-gray-100 border-[#5b53fb]"
        } max-w-7xl mx-auto border rounded-lg shadow-lg p-8`}
      >
        <div className="text-center mb-6">
          <h2 className={`${isDarkTheme ? "text-[#5b53fb]" : "text-[#5b53fb]"} text-2xl font-bold`}>
            Visa Application Form
          </h2>
          <p>Fill out the form below to start your visa application.</p>
        </div>
        <CustomizedForm name="Apply for a Visa" />
      </section>

      {/* Additional Info Section */}
      <section className="py-10">
        <h2
          className={`${
            isDarkTheme ? "text-[#5b53fb]" : "text-[#5b53fb]"
          } text-2xl font-bold text-center mb-6`}
        >
          Why Choose Us?
        </h2>
        <div className="flex flex-wrap justify-center gap-6">
          <div
            className={`${isDarkTheme ? "bg-[#5b53fb]" : "bg-[#dcdafc]"} p-4 rounded-md w-80 text-center`}
          >
            <h3 className="text-lg font-semibold">24/7 Customer Support</h3>
            <p>We're here to help you at every step of your journey.</p>
          </div>
          <div
            className={`${isDarkTheme ? "bg-[#5b53fb]" : "bg-[#dcdafc]"} p-4 rounded-md w-80 text-center`}
          >
            <h3 className="text-lg font-semibold">Affordable Pricing</h3>
            <p>Get the best deals on visa applications and travel packages.</p>
          </div>
          <div
            className={`${isDarkTheme ? "bg-[#5b53fb]" : "bg-[#dcdafc]"} p-4 rounded-md w-80 text-center`}
          >
            <h3 className="text-lg font-semibold">Trusted by Millions</h3>
            <p>Join thousands of happy travelers who trust our services.</p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Visa;
